import Responsive from "./Responsive";
import SmoothScroll from "./SmoothScroll";
import Accordion from "./Accordion";
import Tab from "./Tab";
import SpNavi from "./SpNavi";
import ToTop from "./ToTop";
import DropDownMenu from "./DropDownMenu";
import BlockLink from "./BlockLink";
import Gmap from "./Gmap";
import matchheight from "jquery-match-height";
import link_icon from "./link_icon";
import MainVisual from "./MainVisual";

import Swiper from "swiper/dist/js/swiper.min.js";
/* ===============================================
Check responsive state
=============================================== */
// const r = new Responsive();

// $(window).on('resize',function(){
// check is responsive;
// console.log(r.state()());
// });
// check is mobile;
// alert(r.isPhone());
/* ===============================================
SP Navi
=============================================== */
//通常盤
let param = {
	target: "#spnavi",
	trigger: ".btn_sp_navi",
	filter: "resposive_flg",
	speed: 200
};
const spnavi = new SpNavi(param);
spnavi.exec();

//execに可変引数で処理を渡してナビの開閉時に処理させるサンプル
//例として、SPナビでアコーディオンを開くたびにiScrollをリセットする
// let spnav_accordion_1 = (scroller)=>{
// 	$('#scroller .inner > ul > li > span').off();
// 	$('#scroller .inner > ul > li > span').on('click',function(){
// 		let $parent = $(this).parent('li');
// 		let $child = $(this).next('.gnavi-child');
// 		let status = $child.css('display');

// 		if(status == 'block'){
// 			$child.slideUp(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.removeClass('active');
// 		}else{
// 			$child.slideDown(300,function(){
// 				scroller.refresh();
// 			});
// 			$parent.addClass('active');
// 		}

// 		return false;
// 	});
// }
// spnavi.exec(spnav_accordion_1);
/* ===============================================
box link
=============================================== */
// let box_link = new BlockLink();
// box_link.exec('.box_link');
/* ===============================================
Smooth Scroll
=============================================== */
const sms = new SmoothScroll();
sms.exec();
/* ===============================================
To Top
show/hide toggle
=============================================== */
const totop = new ToTop("#totop", "#global_footer", 100, 400);
totop.exec();

/**
 * 外部リンク・PDF・Word・Exlsに_blankの自動付与
 *
 */
link_icon();
/* ===============================================
DropDown

markp:
<ul>
	<li>
		<a href=""></a>
		<ul class="child">
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
			<li>
				<a href=""></a>
			</li>
		</ul>
	</li>
	<li>
		<a href=""></a>
	</li>
	<li>
		<a href=""></a>
	</li>
</ul>
=============================================== */
// const dd = new DropDownMenu('ul li','.child',200);
// dd.exec();
/* ===============================================
Accordion

markp:
<dl>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
	<dt></dt>
	<dd></dd>
</dl>
=============================================== */
// const ac = new Accordion($('dt'));
// ac.exec();
/* ===============================================
Tab

markup:
<div class="tc">
	<ul>
		<li>tab1</li>
		<li>tab2</li>
		<li>tab3</li>
	</ul>
	<div class="tc_content">
		tabcon1tabcon1tabcon1tabcon1tabcon1tabcon1
	</div>
	<div class="tc_content">
		tabcon2tabcon2tabcon2tabcon2tabcon2tabcon2
	</div>
	<div class="tc_content">
		tabcon3tabcon3tabcon3tabcon3tabcon3tabcon3
	</div>
</div>
=============================================== */
// const tab = new Tab('.tc li','.tc .tc_content');
// tab.exec();

// /* gmap
// ----------------------- */
// let gmap = new Gmap();
// $(window).on('load',function(){
// 	gmap.exec();
// });

/* ===============================================
instagram with infinityScroll

markup:
<div class="slide--instagram_wrapper" id="insragram">
	<div class="slide--instagram">
		<div id="js-slide--instagram">
			<ul class="inner"></ul>
		</div>
	</div>
</div>
=============================================== */
/**
 *
 * @param {sring} requet_url instagramのリクエストURL ./_instagram_template.htmlにhtmlテンプレートサンプルあり
 * @param {element} append_target 読み込んだ写真を追加する要素
 * @param {element} slide_target スライドショーさせる要素
 */
// import instagram from './instagram';
// instagram('request_url','#js-slide--instagram .inner','#js-slide--instagram');

// Main Visual

new MainVisual();

// Header

//$(function(){
const global_header = $(".l-global_header");

if (!$("body").hasClass("home")) {
	$(global_header).addClass("_is-fixed");
} else {
	$(window).on("scroll resize", function() {
		if ($(window).scrollTop() > 300) {
			$(global_header).addClass("_is-fixed");
		} else {
			if ($(global_header).hasClass("_is-fixed")) {
				$(global_header).removeClass("_is-fixed");
			}
		}
	});
}
//});

// Header Current

//$(function(){

const header_list = $(".l-global_header-nav-list-item");

if ($("body").hasClass("page-id-2")) {
	$(header_list[0]).addClass("_is-current");
}
if ($("body").hasClass("page-id-6")) {
	$(header_list[0]).addClass("_is-current");
}

if ($("body").hasClass("page-id-8")) {
	$(header_list[1]).addClass("_is-current");
}
if ($("body").hasClass("page-id-10")) {
	$(header_list[1]).addClass("_is-current");
}

if ($("body").hasClass("post-type-archive-results")) {
	$(header_list[2]).addClass("_is-current");
}
if ($("body").hasClass("single-results")) {
	$(header_list[2]).addClass("_is-current");
}
if ($("body").hasClass("tax-results_tax")) {
	$(header_list[2]).addClass("_is-current");
}

if ($("body").hasClass("post-type-archive-news")) {
	$(header_list[3]).addClass("_is-current");
}
if ($("body").hasClass("single-news")) {
	$(header_list[3]).addClass("_is-current");
}
if ($("body").hasClass("tax-news_tax")) {
	$(header_list[3]).addClass("_is-current");
}

if (
	$("body").hasClass("page-id-353") ||
	$("body").hasClass("parent-pageid-353")
) {
	$(header_list[4]).addClass("_is-current");
}

//});

// FAQ

const faq = $(".js-faq");

$(faq).each(function() {
	let _this = $(this);

	$(_this).on("click", function() {
		if ($(_this).hasClass("_is-active")) {
			$(_this).removeClass("_is-active");
			$(_this)
				.find(".js-faq-fade")
				.slideUp();
		} else {
			$(_this).addClass("_is-active");
			$(_this)
				.find(".js-faq-fade")
				.slideDown();
		}
	});
});

// 施工事例のスライダー

$(function() {
	if ($(".double-swiper").length > 0) {
		const doubleMain = new Swiper(".double-swiper.main", {
			autoplay: false,
			slidesPerView: 1,
			effect: "fade",
			speed: 400,
			speedbetween: 0
		});
		const doubleSub = new Swiper(".double-swiper.sub", {
			centeredSlides: true,
			slidesPerView: 5,
			slideToClickedSlide: true,
			virtualTranslate: true
		});
		doubleMain.controller.control = doubleSub;
		doubleSub.controller.control = doubleMain;
	}
});

// SPナビ

$(".c-naviarea-parent._has-child").each(function() {
	let _this = $(this);

	$(_this).on("click", function() {
		if ($(_this).hasClass("_is-active")) {
			$(_this).removeClass("_is-active");
			$(_this)
				.find(".c-naviarea-child")
				.slideUp(300);
		} else {
			$(_this).addClass("_is-active");
			$(_this)
				.find(".c-naviarea-child")
				.slideDown(300);
		}
	});
});

// ABOUTのスタッフタブ

const staff_tab = $(".c-member_list-cat-item");

$(staff_tab).on("click", function() {
	let _this = $(this);

	if (!$(_this).hasClass("_is-active")) {
		let this_data = $(_this).attr("data-staff_cat");
		let this_text = $(_this).text();

		let staff_cat = [];
		let staff_cat_data = [];

		$(staff_tab).each(function() {
			let tab_text = $(this).text();
			let tab_data = $(this).attr("data-staff_cat");

			if (this_text != tab_text) {
				staff_cat.push(tab_text);
			}
			if (this_data != tab_data) {
				staff_cat_data.push(tab_data);
			}
		});

		$(staff_tab).removeClass("_is-active");
		$(".c-member_list").removeClass("_is-active");

		$(_this).addClass("_is-active");
		$(".js-staff_cat-" + this_data).addClass("_is-active");

		/*staff_cat.some(function(v, i){
			if (v==this_text) staff_cat.splice(i,1);
		});*/

		let i = 0;
		$(".js-other_stafflist").each(function() {
			$(this)
				.find(".js-other_stafflist-text")
				.text(staff_cat[i] + "スタッフ");
			$(this).attr("data-staff_cat", staff_cat_data[i]);
			i++;
		});
	}
});

$(".js-other_stafflist").on("click", function() {
	let this_data = $(this).attr("data-staff_cat");
	//console.log(this_data);

	$(staff_tab).each(function() {
		if ($(this).attr("data-staff_cat") == this_data) {
			//$(window).scrollTop($('.c-member_list-cat').offset().top);
			$(this).click();
		}
	});
});

// リフォーム一覧のカテゴリー

const menu_cat = $(".p-menu-cat_list").find(".cat-item");
const menu_section = $(".p-menu-section");

$(menu_cat).on("click", function() {
	let _this = $(this);

	if (!$(_this).hasClass("current-cat")) {
		let this_data = $(_this).data("menu_cat");

		$(menu_section).removeClass("_is-active");
		$(menu_cat).removeClass("current-cat");

		$(_this).addClass("current-cat");
		$(".js-menu_cat-" + this_data).addClass("_is-active");
	}
});

// SPでは読み込み時にカレント表示を設定する
if(menu_section.length>0){
	const target_array = ['#cat-01','#cat-02','#cat-03','#faq'];
	const hash  = location.hash;
	if(hash){
		// ナビゲーションのカレント表示
		const target_index = target_array.indexOf(hash);
		$('.cat-item').removeClass('current-cat');
		$('.categories ul li').eq(target_index).addClass('current-cat');

		//コンテンツのアクティブ表示
		menu_section.removeClass('_is-active');
		$(hash).addClass('_is-active');
	}
}


// archiveMENU

const archive_list = $(".p-archive_list");
const archive_list_top = $(archive_list).find(".p-archive_list-top");
const categories = $(archive_list).find(".categories");
const cat_item = $(categories).find(".cat-item");
const children = $(categories).find(".children");

// 施工事例を選ぶ 開閉処理

$(archive_list_top).on("click", function() {
	if ($(this).hasClass("_is-active")) {
		$(this).removeClass("_is-active");
		$(categories).slideUp(300);
		$(children).slideUp(300);
		$(cat_item).removeClass("_is-active");
	} else {
		$(this).addClass("_is-active");
		$(categories).slideDown(300);
	}
});

// 施工事例を選ぶ 孫メニューがあるかどうか判定
$(cat_item).each(function() {
	let this_child = $(this).find(".children");

	if ($(this_child).length == 0) {
		$(this).addClass("_hasnt_child");
	}
});

// 各アーティクル

$(".categories > ul > li").each(function() {
	const responsive_flg = $("#responsive_flg");
	if (!$(this).hasClass("_hasnt_child")) {
		let this_child_tagA = $(this).children("a");
		$(this_child_tagA).on("click", function(e) {
			if ($(window).width() < 835) {
				e.preventDefault();
			}
		});
	}
});

$(cat_item).on("click", function() {
	let this_child = $(this).find(".children");
	if ($(this_child).hasClass("_is-active")) {
		$(this).removeClass("_is-active");

		$(this_child).removeClass("_is-active");
		$(this_child)
			.stop()
			.slideUp(300);
	} else {
		$(this).addClass("_is-active");

		$(this_child).addClass("_is-active");
		$(this_child)
			.stop()
			.slideDown(300);
	}
});

// NEWS_SIDEBAR

const news_sidebar = $(".c-news_sidebar");
const news_year = $(news_sidebar).find("p");

$(news_year).on("click", function() {
	if ($(this).hasClass("_is-active")) {
		$(this).removeClass("_is-active");
		$(this)
			.next(".children")
			.slideUp(300);
	} else {
		$(this).addClass("_is-active");
		$(this)
			.next(".children")
			.slideDown(300);
	}
});

//recruit form
//アラート表示 or 確認画面まら入力画面に戻ったらフォームまでスクロール
const input_mail = $(".mw_wp_form_input input[name='your-mail']");
if (input_mail.length > 0) {
	console.log("ok 1");

	if ($(".mw_wp_form .error").length > 0 || input_mail.val() !== "") {
		console.log("ok 2");
		const position = $(".p-formTable").offset().top - 100;
		$("body,html").animate({ scrollTop: position }, 1000, "swing");
	}
}
$(".js-movie-btn").on("click", function() {
	this.classList.add("is-active");
	const video = document.querySelector(".js-recruit-video");
	video.setAttribute("controls", true);
	video.play();
});
